import { render } from "./emptyView.vue?vue&type=template&id=b672ef5c&scoped=true"
import script from "./emptyView.vue?vue&type=script&lang=js"
export * from "./emptyView.vue?vue&type=script&lang=js"

import "./emptyView.vue?vue&type=style&index=0&id=b672ef5c&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b672ef5c"]])

export default __exports__